import { sanitizeHtml } from '../../utils/safeHtml';
import { configDoServiceGroup } from '../../utils/mensagemDoDepartamento';
import { Button, Tab, Tabs, TextField, Typography, Box, Card, CardContent, Checkbox, FormControlLabel, Switch } from '@mui/material'
import React, { useContext, useEffect, useMemo, useRef, useState } from 'react'
import { useLocation, useHistory } from 'react-router-dom'
import { ThemeContext } from '../../components/ThemeContext/ThemeContext';
import { setClosingMsg, setWelcomeMsg, updateUser } from '../../redux/user/user.actions';
import { connect } from 'react-redux';
import {
  getTextConfig,
  getTimeConfig,
  updateTextConfig,
  updateTimeConfig,
  getServiceGroups,
  createServiceGroup,
  updateServiceGroup,
  deleteServiceGroup,
  getOpenHours,
  updateOpenHours,
} from '../../redux/serviceGroup/serviceGroup.actions';
import {
  getProfiles,
  getAvailablePermissions,
  updateProfilePermissions,
  createProfile,
  updateProfileEntity,
  deleteProfile,
} from '../../redux/profile/profile.actions';
import { getUser } from '../../redux/user/user.actions';
import { getInProgressRooms } from '../../redux/room/room.actions';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import Quill from 'quill';
// Registra o blot de imagem que preserva style/width (para redimensionar a
// imagem da mensagem de boas-vindas — item 4 do chat).
import '../../utils/quillImageAttributes';
import QuillImageResizer from '../../components/QuillImageResizer';
import FieldConfigurator from '../../components/FieldConfigurator';
import RegraDeConclusao from '../../components/RegraDeConclusao';
import OperatorsPage from '../OperatorsPage';
import AIConfigurationPage from '../../components/AIConfigurationPage';
import PermissionsAndGroupsPage from '../../components/PermissionsAndGroupsPage';
import TicketStatusConfig from '../../components/TicketStatusConfig';
import TicketSubstatusConfig from '../../components/TicketSubstatusConfig';
import ServiceConfig from '../../components/ServiceConfig';
import MacroConfig from '../../components/MacroConfig';
import LimiteDeAnexo from '../../components/LimiteDeAnexo';
import RemetentesBloqueados from '../../components/RemetentesBloqueados';

/*
 * Quantas abas existem. A aba vem da URL (`?tab=`), e este número é o teto:
 * valor fora da faixa cai na aba 0.
 *
 * Acrescentar um `<Tab>` sem mexer aqui é um defeito SILENCIOSO -- a aba
 * aparece na barra, clicar nela troca a URL, e a tela continua mostrando a
 * primeira. Foi o que aconteceu com "E-mails bloqueados" em 28/10/2026, e só
 * apareceu ao abrir a tela em produção. `settingsTabs.test.js` conta os
 * `<Tab>` do arquivo e compara com este número, para o próximo esquecimento
 * dar teste vermelho em vez de uma aba morta.
 */
const TAB_COUNT = 10; // Mensagens, Campos, Operadores, IA, Permissões e Grupos, Status, Justificativas, Serviços, Macros, E-mails bloqueados

const SettingsPage = props => {
  const location = useLocation();
  const history = useHistory();
  const tabFromUrl = parseInt(new URLSearchParams(location.search).get('tab'), 10);
  const tabValue = (Number.isInteger(tabFromUrl) && tabFromUrl >= 0 && tabFromUrl < TAB_COUNT) ? tabFromUrl : 0;

  const [welcomeMsg, setWelcomeMsg] = useState('');
  const welcomeQuillRef = useRef(null);
  const [closingMsg, setClosingMsg] = useState('');
  const { theme } = useContext(ThemeContext);

  const { textConfigs } = props;
  const { timeConfigs } = props;

  // A config do departamento DO PRÓPRIO ADMIN.
  //
  // Aqui era `textConfigs[0]`, e `GET /text_configs` devolve a lista inteira do
  // tenant: o admin do ADM abria esta tela, via o texto do SUPORTE nas caixas,
  // salvava — e o texto do Suporte era gravado na config do ADM, porque
  // `handleUpdateConfigs()` grava com `currentUser.service_group_id`. A tela
  // corroía por trás o conserto do envio: o cliente configura por departamento e
  // ela sobrescrevia com o de outro, sem avisar.
  //
  // `null` quando o departamento do admin não tem config (departamento novo) ou
  // quando ele não tem departamento (super admin) — e aí é melhor caixa vazia
  // que o texto de outro departamento na frente de quem vai salvar.
  const configDoAdmin = useMemo(
    () => configDoServiceGroup(textConfigs, props.currentUser?.service_group_id),
    [textConfigs, props.currentUser]
  );

  const [inactivityWarningMsg, setInactivityWarningMsg] = useState('');
  const [inactivityClosingMsg, setInactivityClosingMsg] = useState('');
  const [outOfHoursMsg, setOutOfHoursMsg] = useState('');
  const [internalCharacter, setInternalCharacter] = useState('');
  const [closingTime, setClosingTime] = useState('');
  const [warningTime, setWarningTime] = useState('');
  /*
   * O interruptor do encerramento automático (ponto 4 da Gisele,
   * 20/10/2026). Começa LIGADO porque é o comportamento de hoje, e porque
   * é o padrão da coluna no banco.
   */
  const [encerramentoAutomatico, setEncerramentoAutomatico] = useState(true);

  // Horários de serviço (open_hours) do departamento do próprio usuário.
  const { openHours } = props;
  const canManageServiceHours = (props.permissions || []).includes('#gerenciar-horarios-servico');
  const WEEK_DAYS = ['Domingo', 'Segunda-feira', 'Terça-feira', 'Quarta-feira', 'Quinta-feira', 'Sexta-feira', 'Sábado'];
  const emptyHours = () => WEEK_DAYS.map((_, day) => ({ day_of_week: day, opening_time: '', closing_time: '' }));
  const [serviceHours, setServiceHours] = useState(emptyHours());

  const handleTabChange = (event, newValue) => {
    history.push({ pathname: '/configuracoes', search: `?tab=${newValue}` });
    window.dispatchEvent(new CustomEvent('operatorsTabChanged', { detail: { active: newValue === 2 } }));
  };

  useEffect(() => {
    window.dispatchEvent(new CustomEvent('operatorsTabChanged', { detail: { active: tabValue === 2 } }));
    return () => {
      window.dispatchEvent(new CustomEvent('operatorsTabChanged', { detail: { active: false } }));
    };
  }, [tabValue]);


  const handleUpdateConfigs = async () => {
    const textConfigsToUpdate = {};
    const timeConfigToUpdate = {};
    textConfigsToUpdate.service_group_id = props.currentUser.service_group_id;
    timeConfigToUpdate.service_group_id = props.currentUser.service_group_id;

    // Verificações para mensagens de texto
    if (welcomeMsg !== '') {
      textConfigsToUpdate.welcome_message = welcomeMsg;
    }
    if (closingMsg !== '') {
      textConfigsToUpdate.closing_message = closingMsg;
    }
    if (inactivityWarningMsg !== '') {
      textConfigsToUpdate.inactivity_warning_message = inactivityWarningMsg;
    }
    if (inactivityClosingMsg !== '') {
      textConfigsToUpdate.inactivity_closing_message = inactivityClosingMsg;
    }
    if (outOfHoursMsg !== '') {
      textConfigsToUpdate.out_of_hours_message = outOfHoursMsg;
    }
    if (internalCharacter !== '') {
      textConfigsToUpdate.internal_character = internalCharacter;
    }
    // Valor 0 = funcionalidade desativada
    if (closingTime !== '') {
      timeConfigToUpdate.closing_time = Number(closingTime) || 0;
    }
    if (warningTime !== '') {
      timeConfigToUpdate.warning_time = Number(warningTime) || 0;
    }
    // Sempre, e não só quando mudou: é booleano, e "não mandar" seria
    // indistinguível de "desligar" para quem lê do outro lado.
    timeConfigToUpdate.encerramento_automatico = Boolean(encerramentoAutomatico);
    // Chamar a ação de atualização para mensagens de texto se houver alterações
    if (Object.keys(textConfigsToUpdate).length > 0) {
      await props.updateTextConfig(textConfigsToUpdate);
      await props.getTextConfig(props.currentUser.service_group_id)

      // As conversas em andamento carregam a config do departamento DELAS
      // junto da sala, e e dali que a tela tira a despedida no encerramento.
      // Sem recarregar, a copia que a tela segura continua sendo a de antes
      // desta edicao -- o admin salva o texto novo, encerra uma conversa que
      // ja estava aberta, e o cliente recebe o texto ANTIGO. Sem erro, sem
      // log: so um F5 fazia a mudanca valer.
      if (props.currentUser?.id) {
        await props.getInProgressRooms(props.currentUser.id);
      }
    }
    // Chamar a ação de atualização para configuração de tempo se houver alteração
    if (Object.keys(timeConfigToUpdate).length > 0) {
      await props.updateTimeConfig(timeConfigToUpdate);
      await props.getTimeConfig(props.currentUser.service_group_id)
    }

    // Horários de serviço do departamento (somente se o usuário tem a permissão).
    if (canManageServiceHours) {
      const hours = serviceHours.map((h) => ({
        day_of_week: h.day_of_week,
        opening_time: h.opening_time ? h.opening_time : null,
        closing_time: h.closing_time ? h.closing_time : null,
      }));
      await props.updateOpenHours(props.currentUser.service_group_id, hours);
    }
  };

  const SanitizeHTML = ({ htmlContent }) => {
    return (
      <span dangerouslySetInnerHTML={{ __html: sanitizeHtml(htmlContent) }} />
    )
  }

  const CurrentSetting = ({ label, value }) => (
    <Box
      sx={{
        mt: 1.5,
        p: 2,
        borderRadius: 1.5,
        backgroundColor: theme.palette.mode === 'dark' 
          ? 'rgba(255, 255, 255, 0.05)' 
          : 'rgba(0, 0, 0, 0.03)',
        border: `1px solid ${theme.palette.divider}`,
      }}
    >
      <Typography 
        variant="subtitle2" 
        gutterBottom 
        component="div" 
        sx={{ 
          display: 'flex', 
          alignItems: 'center', 
          flexWrap: 'wrap',
          color: theme.palette.text.primary,
          fontWeight: 500,
          '& strong': {
            color: theme.palette.text.primary,
          }
        }}
      >
        <Typography component="span" sx={{ fontWeight: 600, mr: 0.5, color: theme.palette.text.primary }}>
          {label}:
        </Typography>
        <Typography component="span" sx={{ color: theme.palette.text.secondary }}>
          <SanitizeHTML htmlContent={value} />
        </Typography>
      </Typography>
    </Box>
  );

  const normalizeData = (data) => {
    if (data && Array.isArray(data)) {
      return data[0];
    }
    return data;
  };

  useEffect(() => {
    const normalizedTextConfig = normalizeData(configDoAdmin);
    // A guarda é o PRÓPRIO registro, e não `textConfigs.length`: a lista chega
    // cheia (é a do tenant todo) mesmo quando o departamento deste admin não tem
    // config nenhuma, e aí o `length` deixava passar um `undefined` para os
    // `set...` abaixo.
    if (normalizedTextConfig) {
      setWelcomeMsg(normalizedTextConfig.welcome_message);
      setClosingMsg(normalizedTextConfig.closing_message);
      setInactivityWarningMsg(normalizedTextConfig.inactivity_warning_message);
      setInactivityClosingMsg(normalizedTextConfig.inactivity_closing_message);
      setOutOfHoursMsg(normalizedTextConfig.out_of_hours_message || '');
      setInternalCharacter(normalizedTextConfig.internal_character);
    }
    if (timeConfigs.length > 0) {
      // Valor padrão: 0 (desativa a funcionalidade)
      // Para reativar, altere o valor padrão para o desejado (ex: 30)
      setClosingTime(timeConfigs[0]?.closing_time || 0);
      setWarningTime(timeConfigs[0]?.warning_time || 0);
      /*
       * `!== false`: a api devolve `true`, `false`, `1`, `0` -- e, num
       * tenant cuja configuração é anterior à coluna, `undefined`. Só o
       * `false` explícito desliga; o resto é o padrão ligado. `Boolean()`
       * aqui transformaria o `undefined` em desligado e tiraria o
       * encerramento de quem nunca pediu isso.
       */
      setEncerramentoAutomatico(timeConfigs[0]?.encerramento_automatico !== false);
    } else {
      // Se não houver configuração, define 0 como padrão (desativado)
      setClosingTime(0);
      setWarningTime(0);
    }
  }, [configDoAdmin, timeConfigs]);

  // Carrega os horários de serviço do departamento do usuário quando ele tem a permissão.
  useEffect(() => {
    if (canManageServiceHours && props.currentUser?.service_group_id) {
      props.getOpenHours(props.currentUser.service_group_id);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [canManageServiceHours, props.currentUser?.service_group_id]);

  // Sincroniza os horários vindos do backend com os 7 dias editáveis (preenche dias faltantes).
  useEffect(() => {
    const toHM = (t) => (t ? String(t).slice(0, 5) : '');
    const byDay = {};
    (openHours || []).forEach((h) => { byDay[h.day_of_week] = h; });
    setServiceHours(WEEK_DAYS.map((_, day) => ({
      day_of_week: day,
      opening_time: toHM(byDay[day]?.opening_time),
      closing_time: toHM(byDay[day]?.closing_time),
    })));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [openHours]);

  const handleServiceHourChange = (day, field, value) => {
    setServiceHours((prev) => prev.map((h) => (h.day_of_week === day ? { ...h, [field]: value } : h)));
  };

  const handleToggleDayClosed = (day, closed) => {
    setServiceHours((prev) => prev.map((h) => (
      h.day_of_week === day
        ? { ...h, opening_time: closed ? '' : (h.opening_time || '08:00'), closing_time: closed ? '' : (h.closing_time || '18:00') }
        : h
    )));
  };

  const Link = Quill.import('formats/link');
  Link.sanitize = function (url) {
    if (!url.startsWith('http://') && !url.startsWith('https://')) {
      return `http://${url}`
    }
    return url;
  }

  const modules = useMemo(() => ({
    toolbar: {
      container: [
        ["bold", "italic", "underline", "strike", "blockquote"],
        [{ list: "ordered" }, { list: "bullet" }, { indent: "-1" }, { indent: "+1" }],
        ["link", "image"],
        ["clean"],
      ],
    },
    clipboard: {
      matchVisual: false,
    },
  }), [])

  useEffect(() => {
    const interval = setInterval(() => {
      const tooltips = document.querySelectorAll('.ql-snow .ql-tooltip[data-mode="link"]');
      tooltips.forEach(tooltip => {
        const input = tooltip.querySelector('input[type=text]');
        if (input && input.placeholder !== 'http://sysfar.com.br') {
          input.placeholder = 'http://sysfar.com.br'; // Define o novo valor do placeholder
        }
      });

      if (tooltips.length) clearInterval(interval);
    }, 1000);

    return () => clearInterval(interval);
  }, []);


  return (
    <Box sx={{ height: '100%', display: 'flex', flexDirection: 'column', overflow: 'hidden', backgroundColor: theme.palette.background.default }}>
      {/* Header com Tabs Modernas */}
      <Box 
        sx={{
          px: 3,
          py: 2,
        }}
      >
        {/*
          * As dez seções, todas visíveis, em duas linhas.
          *
          * Antes isto era `variant="scrollable"`: a tira media 1.395px de
          * conteúdo em 798px visíveis, mostrava CINCO das dez e não
          * desenhava nenhum botão de rolagem. Metade das configurações --
          * "Serviços", "Macros", "E-mails bloqueados" -- só aparecia para
          * quem adivinhasse que aquela faixa rolava para o lado. Não é um
          * problema de estética: é função que não se encontra.
          *
          * O `flexWrap: 'wrap'` do Box em volta já estava aqui, de alguém
          * que quis exatamente isto; o `scrollable` é que força uma linha só
          * e o ignora. Trocando para `standard` e deixando o contêiner
          * quebrar, as dez cabem. Custa cerca de 40px de altura, uma vez, no
          * topo de uma tela de formulários longos.
          *
          * Continua sendo `Tabs`, e não uma lista de botões, para não perder
          * a navegação por teclado e o `role="tablist"`. O indicador já
          * estava escondido (o estado ativo é a pílula preenchida), então
          * quebrar linha não desalinha nada.
          */}
        <Box
          sx={{
            display: 'flex',
            gap: 1,
            flexWrap: 'wrap',
            backgroundColor: theme.palette.background.paper,
            padding: '8px',
            // 3 aqui seriam 30px: o número puro multiplica
            // `theme.shape.borderRadius`, que neste projeto é 10.
            borderRadius: '12px',
            border: `1px solid ${theme.palette.divider}`,
          }}
        >
          <Tabs
            value={tabValue}
            onChange={handleTabChange}
            variant="standard"
            sx={{
              minHeight: 'auto',
              width: '100%',
              '& .MuiTabs-indicator': {
                display: 'none',
              },
              '& .MuiTabs-flexContainer': {
                gap: 1,
                flexWrap: 'wrap',
              },
              '& .MuiTab-root': {
                textTransform: 'none',
                fontWeight: 500,
                fontSize: '0.875rem',
                minHeight: 36,
                padding: '8px 16px',
                borderRadius: 2,
                color: theme.palette.text.secondary,
                transition: 'all 0.2s ease',
                '&:hover': {
                  backgroundColor: theme.palette.mode === 'dark' 
                    ? 'rgba(255, 255, 255, 0.08)' 
                    : 'rgba(0, 0, 0, 0.04)',
                },
                '&.Mui-selected': {
                  /*
                   * A aba ativa era a mais difícil de ler da tira, nos DOIS
                   * temas, por motivos opostos -- e as inativas estavam em
                   * 7,58:1:
                   *
                   *   claro:  `#63A5C7` chumbado + texto branco -> 2,71:1
                   *   escuro: primária `#63ace5` + texto branco -> 2,45:1
                   *
                   * No claro o fundo era claro demais; no escuro a primária é
                   * um azul CLARO, e branco sobre ela some. Escrever branco
                   * nos dois casos é que estava errado: num tema a pílula é
                   * escura, no outro é clara.
                   *
                   * `getContrastText` resolve isso calculando em vez de
                   * adivinhar -- devolve branco sobre a primária do claro
                   * (`#1e4d72`, 8,90:1) e texto escuro sobre a do escuro
                   * (`#63ace5`, 7,5:1). E usar a primária em vez de um azul
                   * chumbado faz a seleção conversar com o shell.
                   */
                  color: theme.palette.getContrastText(theme.palette.primary.main),
                  backgroundColor: theme.palette.primary.main,
                  fontWeight: 600,
                },
              },
            }}
          >
            <Tab label="Mensagens" />
            <Tab label="Configurações de Campos de Tickets" />
            <Tab label="Operadores" />
            <Tab label="IA" />
            <Tab label="Permissões e Grupos" />
            <Tab label="Status de Tickets" />
            <Tab label="Justificativas" />
            <Tab label="Serviços" />
            <Tab label="Macros" />
            {/* Pontos 6 e 7 da Gisele (27/10/2026). */}
            <Tab label="E-mails bloqueados" />
          </Tabs>
        </Box>
      </Box>
      {/* Conteúdo Principal */}
      <Box sx={{ 
        px: 3, 
        pt: 2,
        pb: 3, 
        flex: 1, 
        overflow: 'auto', 
        minHeight: 0,
        scrollbarGutter: 'stable',
      }}>
        {tabValue === 0 && (
          <Card 
            elevation={0}
            sx={{
              backgroundColor: theme.palette.background.paper,
              border: `1px solid ${theme.palette.divider}`,
              borderRadius: 2,
              overflow: 'hidden',
            }}
          >
            <CardContent sx={{ p: 3 }}>
              <Typography variant="h5" sx={{ fontWeight: 600, mb: 1, color: theme.palette.text.primary }}>
                Mensagens Automáticas
              </Typography>
              <Typography variant="body2" sx={{ color: theme.palette.text.secondary, mb: 3 }}>
                Configure as mensagens que serão enviadas automaticamente para os visitantes.
              </Typography>

              <Box sx={{ mb: 4 }}>
                <Typography variant="subtitle2" sx={{ fontWeight: 600, mb: 1.5, color: theme.palette.text.primary }}>
                  Mensagem de Boas-vindas
                </Typography>
                <Box sx={{ mb: 2, border: `1px solid ${theme.palette.divider}`, borderRadius: 1 }}>
                  <ReactQuill ref={welcomeQuillRef} value={welcomeMsg} onChange={(e) => setWelcomeMsg(e)} modules={modules} />
                  <QuillImageResizer quillRef={welcomeQuillRef} onCommit={setWelcomeMsg} />
                </Box>
                <CurrentSetting
                  label="Mensagem de Boas Vindas Atual"
                  value={welcomeMsg || configDoAdmin?.welcome_message}
                />
              </Box>

              <Box sx={{ mb: 3 }}>
                <Typography variant="subtitle2" sx={{ fontWeight: 600, mb: 1.5, color: theme.palette.text.primary }}>
                  Mensagem de Encerramento
                </Typography>
                <Box sx={{ mb: 2, border: `1px solid ${theme.palette.divider}`, borderRadius: 1 }}>
                  <ReactQuill value={closingMsg} onChange={(e) => setClosingMsg(e)} modules={modules} />
                </Box>
                <CurrentSetting
                  label="Mensagem de Encerramento Atual"
                  value={closingMsg || configDoAdmin?.closing_message}
                />
              </Box>

              <Box sx={{ mb: 3 }}>
                <Typography variant="subtitle2" sx={{ fontWeight: 600, mb: 1.5, color: theme.palette.text.primary }}>
                  Mensagem de Fora do Horário
                </Typography>
                <Typography variant="body2" sx={{ color: theme.palette.text.secondary, mb: 1.5 }}>
                  Exibida ao cliente quando o chat está fora do horário de atendimento. Você pode usar as
                  variáveis <strong>{'{horario_inicio}'}</strong> e <strong>{'{horario_fim}'}</strong>, que
                  são substituídas pelos horários reais do departamento. Ex.: “Estamos fechados. Funcionamos
                  das {'{horario_inicio}'} às {'{horario_fim}'}.”
                </Typography>
                <TextField
                  fullWidth
                  multiline
                  minRows={3}
                  value={outOfHoursMsg}
                  onChange={(e) => setOutOfHoursMsg(e.target.value)}
                  placeholder="Ex.: Estamos fora do horário de atendimento. Funcionamos das {horario_inicio} às {horario_fim}."
                />
              </Box>

              <Box sx={{ mb: 4, mt: 4, pt: 3, borderTop: `1px solid ${theme.palette.divider}` }}>
                <Typography variant="subtitle2" sx={{ fontWeight: 600, mb: 1.5, color: theme.palette.text.primary }}>
                  Configurações de Mensagens Internas
                </Typography>
                <Typography variant="body2" sx={{ color: theme.palette.text.secondary, mb: 2 }}>
                  Configure o caractere utilizado para identificar mensagens internas.
                </Typography>
                <TextField
                  label="Caractere Interno"
                  variant="outlined"
                  fullWidth
                  value={internalCharacter}
                  onChange={(e) => setInternalCharacter(e.target.value)}
                  placeholder="Insira um novo Caractere interno"
                  sx={{ mb: 2 }}
                />
                <CurrentSetting
                  label="Caractere Interno Atual"
                  value={internalCharacter || configDoAdmin?.internal_character || 'Não configurado'}
                />
              </Box>

              <Box sx={{ mb: 4, mt: 4, pt: 3, borderTop: `1px solid ${theme.palette.divider}` }}>
                <Typography variant="subtitle2" sx={{ fontWeight: 600, mb: 0.5, color: theme.palette.text.primary }}>
                  Temporizador de Inatividade
                </Typography>
                <Typography variant="body2" sx={{ color: theme.palette.text.secondary, mb: 2 }}>
                  Defina (em minutos) quanto tempo sem interação do cliente até enviar o aviso automático e até encerrar o chat. Use 0 para desativar.
                </Typography>

                {/*
                  * Desligar SEM apagar os tempos (ponto 4 da Gisele,
                  * 20/10/2026): "opção para desligar o encerramento
                  * automático quando precisar, mantendo a contagem do tempo
                  * só para acompanhamento".
                  *
                  * O jeito de hoje é zerar os dois campos acima -- e aí os
                  * números se perdem. Quem desliga num dia de pico não
                  * lembra deles para religar.
                  *
                  * Desligado, nada sai automaticamente: nem o encerramento
                  * nem o AVISO. O aviso diz que a conversa vai ser
                  * encerrada, e mandá-lo aqui seria avisar de algo que não
                  * vai acontecer. Está escrito na tela porque ninguém
                  * adivinha.
                  */}
                <FormControlLabel
                  sx={{ mb: 2, display: 'block' }}
                  control={(
                    <Switch
                      checked={encerramentoAutomatico}
                      onChange={(e) => setEncerramentoAutomatico(e.target.checked)}
                      inputProps={{ 'aria-label': 'Encerrar conversas paradas automaticamente' }}
                    />
                  )}
                  label={(
                    <Box>
                      <Typography variant="body2" sx={{ color: theme.palette.text.primary }}>
                        Encerrar conversas paradas automaticamente
                      </Typography>
                      <Typography variant="caption" sx={{ color: theme.palette.text.secondary }}>
                        {encerramentoAutomatico
                          ? 'Os tempos abaixo valem: a conversa parada recebe o aviso e depois é encerrada.'
                          : 'Desligado: nenhuma conversa é encerrada nem avisada. Os tempos abaixo ficam guardados para quando você religar.'}
                      </Typography>
                    </Box>
                  )}
                />

                <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap', mb: 2 }}>
                  <TextField
                    label="Tempo para aviso (min)"
                    type="number"
                    variant="outlined"
                    value={warningTime}
                    onChange={(e) => setWarningTime(e.target.value)}
                    inputProps={{ min: 0 }}
                    sx={{ flex: 1, minWidth: 180 }}
                  />
                  <TextField
                    label="Tempo para encerramento (min)"
                    type="number"
                    variant="outlined"
                    value={closingTime}
                    onChange={(e) => setClosingTime(e.target.value)}
                    inputProps={{ min: 0 }}
                    sx={{ flex: 1, minWidth: 180 }}
                  />
                </Box>

                {Number(warningTime) > 0 && Number(closingTime) > 0 && Number(warningTime) >= Number(closingTime) && (
                  <Typography variant="caption" sx={{ display: 'block', mb: 2, color: theme.palette.error.main }}>
                    O tempo de aviso deve ser menor que o tempo de encerramento.
                  </Typography>
                )}

                <TextField
                  label="Mensagem de aviso de inatividade"
                  variant="outlined"
                  fullWidth
                  multiline
                  minRows={2}
                  value={inactivityWarningMsg || ''}
                  onChange={(e) => setInactivityWarningMsg(e.target.value)}
                  placeholder="Ex: Esta conversa será encerrada em breve devido à inatividade."
                  sx={{ mb: 2 }}
                />
                <TextField
                  label="Mensagem de encerramento por inatividade"
                  variant="outlined"
                  fullWidth
                  multiline
                  minRows={2}
                  value={inactivityClosingMsg || ''}
                  onChange={(e) => setInactivityClosingMsg(e.target.value)}
                  placeholder="Ex: Conversa encerrada automaticamente por inatividade."
                  sx={{ mb: 1 }}
                />
                <CurrentSetting
                  label="Configuração atual"
                  value={timeConfigs[0]?.encerramento_automatico === false
                    ? `Desligado (guardado: aviso ${timeConfigs[0]?.warning_time ?? 0} min · encerramento ${timeConfigs[0]?.closing_time ?? 0} min)`
                    : `Aviso: ${timeConfigs[0]?.warning_time ?? 0} min · Encerramento: ${timeConfigs[0]?.closing_time ?? 0} min`}
                />
              </Box>

              {canManageServiceHours && (
                <Box sx={{ mb: 4, mt: 4, pt: 3, borderTop: `1px solid ${theme.palette.divider}` }}>
                  <Typography variant="subtitle2" sx={{ fontWeight: 600, mb: 0.5, color: theme.palette.text.primary }}>
                    Horários de Serviço
                  </Typography>
                  <Typography variant="body2" sx={{ color: theme.palette.text.secondary, mb: 2 }}>
                    Defina os horários de atendimento do seu departamento por dia da semana. Marque "Fechado" para dias sem atendimento.
                  </Typography>

                  {serviceHours.map((h) => {
                    const closed = !h.opening_time && !h.closing_time;
                    return (
                      <Box key={h.day_of_week} sx={{ display: 'flex', alignItems: 'center', gap: 2, flexWrap: 'wrap', mb: 1.5 }}>
                        <Typography variant="body2" sx={{ width: 120, fontWeight: 500, color: theme.palette.text.primary }}>
                          {WEEK_DAYS[h.day_of_week]}
                        </Typography>
                        <TextField
                          label="Abertura"
                          type="time"
                          size="small"
                          value={h.opening_time}
                          onChange={(e) => handleServiceHourChange(h.day_of_week, 'opening_time', e.target.value)}
                          disabled={closed}
                          InputLabelProps={{ shrink: true }}
                          sx={{ width: 140 }}
                        />
                        <TextField
                          label="Fechamento"
                          type="time"
                          size="small"
                          value={h.closing_time}
                          onChange={(e) => handleServiceHourChange(h.day_of_week, 'closing_time', e.target.value)}
                          disabled={closed}
                          InputLabelProps={{ shrink: true }}
                          sx={{ width: 140 }}
                        />
                        <FormControlLabel
                          control={<Checkbox checked={closed} onChange={(e) => handleToggleDayClosed(h.day_of_week, e.target.checked)} />}
                          label="Fechado"
                        />
                      </Box>
                    );
                  })}
                </Box>
              )}

              {/*
                O limite de anexo e da EMPRESA, nao do departamento -- por isso
                ele tem secao propria e salva sozinho, sem passar pelo "Salvar
                Alteracoes" logo abaixo, que grava as configuracoes do grupo.
                O componente nao aparece para quem nao e administrador.
              */}
              <LimiteDeAnexo theme={theme} />

              <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 3, pt: 2, borderTop: `1px solid ${theme.palette.divider}` }}>
                <Button
                  variant="contained"
                  sx={{
                    backgroundColor: theme.palette.button.secondary,
                    textTransform: 'none',
                    px: 3,
                    py: 1,
                    fontWeight: 600,
                  }}
                  onClick={() => handleUpdateConfigs()}
                >
                  Salvar Alterações
                </Button>
              </Box>

              <Box 
                sx={{ 
                  mt: 3, 
                  p: 2, 
                  backgroundColor: theme.palette.mode === 'dark' 
                    ? 'rgba(255, 255, 255, 0.05)' 
                    : 'rgba(0, 0, 0, 0.03)', 
                  borderRadius: 1.5,
                  border: `1px solid ${theme.palette.divider}`,
                }}
              >
                <Typography 
                  variant="subtitle2" 
                  sx={{ 
                    display: 'block', 
                    mb: 1.5, 
                    fontWeight: 600, 
                    color: theme.palette.text.primary 
                  }}
                >
                  Nota:
                </Typography>
                <Typography 
                  variant="body2" 
                  sx={{ 
                    display: 'block', 
                    mb: 1, 
                    color: theme.palette.text.secondary,
                    '& b, & strong': {
                      color: theme.palette.text.primary,
                      fontWeight: 600,
                    }
                  }}
                >
                  <b>Mensagem de Boas-vindas:</b> Esta mensagem será enviada automaticamente aos clientes quando iniciarem uma conversa.
                </Typography>
                <Typography 
                  variant="body2" 
                  sx={{ 
                    display: 'block', 
                    color: theme.palette.text.secondary,
                    '& b, & strong': {
                      color: theme.palette.text.primary,
                      fontWeight: 600,
                    }
                  }}
                >
                  <b>Mensagem de Encerramento:</b> Esta mensagem será enviada automaticamente aos clientes quando uma conversa for concluída.
                </Typography>
              </Box>
            </CardContent>
          </Card>
        )}

        {/* Configuração de campos de tickets */}
        {tabValue === 1 && (
          <Card 
            elevation={0}
            sx={{
              backgroundColor: theme.palette.background.paper,
              border: `1px solid ${theme.palette.divider}`,
              borderRadius: 2,
              overflow: 'hidden',
            }}
          >
            <CardContent sx={{ p: 3 }}>
              <Typography variant="h5" sx={{ fontWeight: 600, mb: 1, color: theme.palette.text.primary }}>
                Configurações de Campos de Tickets
              </Typography>
              <Typography variant="body2" sx={{ color: theme.palette.text.secondary, mb: 3 }}>
                Configure os campos personalizados para os tickets.
              </Typography>
              {/*
                Vem ANTES dos campos personalizados de propósito: é regra de
                conclusão, não cadastro de campo, e misturar as duas coisas na
                mesma lista faria parecer que o `required` de um campo
                personalizado também vale ao encerrar -- não vale.
              */}
              <RegraDeConclusao />
              <FieldConfigurator />
            </CardContent>
          </Card>
        )}

        {/* Tab de Operadores */}
        {tabValue === 2 && (
          <Box sx={{ 
            backgroundColor: theme.palette.background.default,
            borderRadius: 2,
            position: 'relative',
          }}>
            <OperatorsPage {...props} />
          </Box>
        )}

        {/* Tab de IA */}
        {tabValue === 3 && (
          <Box sx={{ 
            backgroundColor: theme.palette.background.default,
            borderRadius: 2,
            position: 'relative',
          }}>
            <AIConfigurationPage {...props} />
          </Box>
        )}

        {/* Tab Permissões e Grupos */}
        {tabValue === 4 && (
          <Box sx={{ 
            backgroundColor: theme.palette.background.default,
            borderRadius: 2,
            position: 'relative',
          }}>
            <PermissionsAndGroupsPage {...props} />
          </Box>
        )}

        {/* Tab Status de Tickets */}
        {tabValue === 5 && (
          <Box sx={{ 
            backgroundColor: theme.palette.background.default,
            borderRadius: 2,
            position: 'relative',
          }}>
            <TicketStatusConfig />
          </Box>
        )}

        {/* Tab Justificativas (Substatus) */}
        {tabValue === 6 && (
          <Box sx={{ 
            backgroundColor: theme.palette.background.default,
            borderRadius: 2,
            position: 'relative',
          }}>
            <TicketSubstatusConfig />
          </Box>
        )}

        {/* Tab Serviços */}
        {tabValue === 7 && (
          <Box sx={{ 
            backgroundColor: theme.palette.background.default,
            borderRadius: 2,
            position: 'relative',
          }}>
            <ServiceConfig />
          </Box>
        )}

        {/* Tab Macros */}
        {tabValue === 8 && (
          <Box sx={{ 
            backgroundColor: theme.palette.background.default,
            borderRadius: 2,
            position: 'relative',
          }}>
            <MacroConfig />
          </Box>
        )}
        {tabValue === 9 && (
          <Box sx={{
            backgroundColor: theme.palette.background.default,
            borderRadius: 2,
            position: 'relative',
          }}>
            <RemetentesBloqueados />
          </Box>
        )}
      </Box>
    </Box>
  )
}

const mapDispatchToProps = (dispatch) => ({
  setWelcomeMsg: (msg) => dispatch(setWelcomeMsg(msg)),
  setClosingMsg: (msg) => dispatch(setClosingMsg(msg)),
  updateUser: (user) => dispatch(updateUser(user)),
  updateTextConfig: (textConfigs) => dispatch(updateTextConfig(textConfigs)),
  updateTimeConfig: (timeConfigs) => dispatch(updateTimeConfig(timeConfigs)),
  getTextConfig: (serviceGroupId) => dispatch(getTextConfig(serviceGroupId)),
  getTimeConfig: (serviceGroupId) => dispatch(getTimeConfig(serviceGroupId)),
  getOpenHours: (serviceGroupId) => dispatch(getOpenHours(serviceGroupId)),
  updateOpenHours: (serviceGroupId, hours) => dispatch(updateOpenHours(serviceGroupId, hours)),
  getServiceGroups: () => dispatch(getServiceGroups()),
  createServiceGroup: (data) => dispatch(createServiceGroup(data)),
  updateServiceGroup: (data) => dispatch(updateServiceGroup(data)),
  deleteServiceGroup: (id) => dispatch(deleteServiceGroup(id)),
  getProfiles: (withPermissions) => dispatch(getProfiles(withPermissions)),
  getAvailablePermissions: () => dispatch(getAvailablePermissions()),
  updateProfilePermissions: (profileId, permissions) => dispatch(updateProfilePermissions(profileId, permissions)),
  createProfile: (data) => dispatch(createProfile(data)),
  updateProfileEntity: (profile) => dispatch(updateProfileEntity(profile)),
  deleteProfile: (id) => dispatch(deleteProfile(id)),
  getUser: (id) => dispatch(getUser(id)),
  getInProgressRooms: (operatorId) => dispatch(getInProgressRooms(operatorId)),
});

const mapStateToProps = (state) => {
  const { user, serviceGroups, profiles } = state;
  const { textConfigs, timeConfigs, openHours } = serviceGroups;
  const { currentUser, users, permissions } = user;

  return {
    currentUser,
    textConfigs,
    timeConfigs,
    openHours,
    users,
    serviceGroups: serviceGroups.serviceGroups,
    profiles: profiles.profiles,
    availablePermissions: profiles.availablePermissions,
    permissions: permissions || []
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(SettingsPage); 